<div
    class="side-navbar"
    [ngClass]="ctx.collapsed ? 'collapsed' : 'sidebar-open'"
    *ngrxLet="{ customization: customization$, collapsed: collapsed$, activeMenu: activeMenu$, user: user$, collapsedItem: collapsedItem$ } as ctx"
>
    <nav>
        <div class="logo p-2 pb-5">
            <p-image src="{{ 'data:image/png;base64,' + ctx.customization?.logoData }}" alt="Logo" height="40" *ngIf="!!ctx.customization?.logoData"></p-image>
            <p-image src="../../assets/image/sf-fitness-icon-x.png" alt="Logo" height="40" *ngIf="ctx.collapsed && !ctx.customization?.logoData"></p-image>
            <p-image src="../../assets/image/sf-fitness-logo_weiss.png" alt="Logo" height="40" *ngIf="!ctx.collapsed && !ctx.customization?.logoData"></p-image>
        </div>
        <ul class="menu d-flex flex-column align-items-center justify-content-center p-0 m-0">
            <ng-container *ngIf="userHasOneRoleOf(ctx.user, ['maintenance', 'admin', 'instructor'])">
                <li
                    class="nav-item d-flex flex-column align-items-center pt-3 pb-3"
                    [ngClass]="{ active: ctx.activeMenu === 'calendar', collapsed: ctx.collapsedItem['calendar'] }"
                    (click)="toggleCollapseSubmenu('calendar')"
                >
                    <div class="nav-item-content d-flex flex-row align-items-center">
                        <div class="d-flex flex-row align-items-center">
                            <i class="pi pi-fw pi-calendar icon"></i>
                            <div class="nav-item-title">{{ 'CALENDAR_NAVIGATION_TITLE' | translate }}</div>
                        </div>
                        <div>
                            <i class="pi pi-fw pi-angle-down toggle-icon" *ngIf="!ctx.collapsedItem['calendar']"></i>
                            <i class="pi pi-fw pi-angle-left toggle-icon" *ngIf="ctx.collapsedItem['calendar']"></i>
                        </div>
                    </div>
                    <ul class="submenu dropdown m-0">
                        <li class="dropdown-item">
                            <a [routerLink]="'/calendar/admin'">
                                {{ 'CALENDAR_ADMIN_PAGE_TITLE' | translate }}
                            </a>
                        </li>
                        <li class="dropdown-item">
                            <a [routerLink]="'/calendar/member'">
                                {{ 'CALENDAR_NAVIGATION_MEMBER' | translate }}
                            </a>
                        </li>
                        <li class="dropdown-item" [routerLink]="'/calendar/sidebar-calendar/plugin/configuration'">
                            <a>{{ 'TRAININGLEVEL_MANAGEMENT_PAGE_TITLE' | translate }}</a>
                        </li>
                        <ng-container *ngIf="userHasOneRoleOf(ctx.user, ['maintenance', 'admin'])">
                            <li class="dropdown-item">
                                <a [routerLink]="'/calendar/plugin/configuration'">
                                    {{ 'CALENDAR_NAVIGATION_PLUGIN_CONFIGURATION' | translate }}
                                </a>
                            </li>
                        </ng-container>
                    </ul>
                </li>
            </ng-container>

            <ng-container *ngIf="userHasOneRoleOf(ctx.user, ['maintenance', 'admin'])">
                <li
                    class="nav-item d-flex flex-column align-items-center pt-3 pb-3"
                    [ngClass]="{ active: ctx.activeMenu === 'contingent', collapsed: ctx.collapsedItem['contingent'] }"
                    (click)="toggleCollapseSubmenu('contingent')"
                >
                    <div class="nav-item-content d-flex flex-row align-items-center">
                        <div class="d-flex flex-row align-items-center">
                            <i class="pi pi-fw pi-money-bill icon"></i>
                            <div class="nav-item-title">{{ 'CONTINGENT_NAVIGATION_TITLE' | translate }}</div>
                        </div>
                        <div>
                            <i class="pi pi-fw pi-angle-down toggle-icon" *ngIf="!ctx.collapsedItem['contingent']"></i>
                            <i class="pi pi-fw pi-angle-left toggle-icon" *ngIf="ctx.collapsedItem['contingent']"></i>
                        </div>
                    </div>
                    <ul class="submenu dropdown m-0">
                        <li class="dropdown-item">
                            <a>
                                {{ 'CORE_CONTINGENT_BUNDLE_PANEL_TITLE' | translate }}
                            </a>
                        </li>
                        <li class="dropdown-item">
                            <a>
                                {{ 'CORE_CONTINGENT_ASSIGNMENT_PANEL_TITLE' | translate }}
                            </a>
                        </li>
                        <li class="dropdown-item">
                            <a>{{ 'CORE_CONTINGENT_USAGE_OVERVIEW_PANEL_TITLE' | translate }}</a>
                        </li>
                        <li class="dropdown-item">
                            <a>{{ 'CORE_CONTINGENT_ASSIGNMENT_OVERVIEW_PANEL_TITLE' | translate }}</a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item d-flex flex-column align-items-center pt-3 pb-3" [ngClass]="{ active: ctx.activeMenu === 'statistics' }">
                    <div class="nav-item-content d-flex flex-row align-items-center">
                        <div class="d-flex flex-row align-items-center">
                            <i class="pi pi-fw pi-chart-line icon"></i>
                            <div class="nav-item-title">{{ 'STATISTICS_NAVIGATION_TITLE' | translate }}</div>
                        </div>
                    </div>
                </li>
                <li
                    class="nav-item d-flex flex-column align-items-center pt-3 pb-3"
                    [ngClass]="{ active: ctx.activeMenu === 'usermanagement' }"
                    (click)="navigate('usermanagement')"
                >
                    <div class="nav-item-content d-flex flex-row align-items-center">
                        <div class="d-flex flex-row align-items-center">
                            <i class="pi pi-fw pi-users icon"></i>
                            <div class="nav-item-title">{{ 'USERMANAGEMENT_NAVIGATION_TITLE' | translate }}</div>
                        </div>
                    </div>
                </li>
                <li class="nav-item d-flex flex-column align-items-center pt-3 pb-3" [ngClass]="{ active: ctx.activeMenu === 'accounting' }">
                    <div class="nav-item-content d-flex flex-row align-items-center">
                        <div class="d-flex flex-row align-items-center">
                            <i class="pi pi-fw pi-credit-card icon"></i>
                            <div class="nav-item-title">{{ 'NAVIGATION_ACCOUNTING' | translate }}</div>
                        </div>
                    </div>
                </li>
                <li
                    class="nav-item d-flex flex-column align-items-center pt-3 pb-3"
                    [ngClass]="{ active: ctx.activeMenu === 'cms', collapsed: ctx.collapsedItem['cms'] }"
                    (click)="toggleCollapseSubmenu('cms')"
                >
                    <div class="nav-item-content d-flex flex-row align-items-center">
                        <div class="d-flex flex-row align-items-center">
                            <i class="pi pi-fw pi-book icon"></i>
                            <div class="nav-item-title">{{ 'CMS_PAGE_TITLE' | translate }}</div>
                        </div>
                        <div>
                            <i class="pi pi-fw pi-angle-down toggle-icon" *ngIf="!ctx.collapsedItem['cms']"></i>
                            <i class="pi pi-fw pi-angle-left toggle-icon" *ngIf="ctx.collapsedItem['cms']"></i>
                        </div>
                    </div>
                    <ul class="submenu dropdown m-0">
                        <li class="dropdown-item">
                            <a>
                                {{ 'CMS_NAVIGATION_ADMIN' | translate }}
                            </a>
                        </li>
                        <li class="dropdown-item">
                            <a>
                                {{ 'CMS_NAVIGATION_NEWSFEED' | translate }}
                            </a>
                        </li>
                        <li class="dropdown-item">
                            <a>
                                {{ 'CMS_USER_UNLOCK_TITLE' | translate }}
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item d-flex flex-column align-items-center pt-3 pb-3" [ngClass]="{ active: ctx.activeMenu === 'configuration' }">
                    <div class="nav-item-content d-flex flex-row align-items-center">
                        <div class="d-flex flex-row align-items-center">
                            <i class="pi pi-fw pi-cog icon"></i>
                            <div class="nav-item-title">{{ 'CONFIGURATION_NAVIGATION_TITLE' | translate }}</div>
                        </div>
                    </div>
                </li>
            </ng-container>

            <ng-container *ngIf="userHasOneRoleOf(ctx.user, ['member', 'dummy_user'], ['maintenance', 'admin', 'instructor'])">
                <li class="nav-item d-flex flex-column align-items-center pt-3 pb-3" [ngClass]="{ active: ctx.activeMenu === 'calendar' }" [routerLink]="'/calendar/member'">
                    <div class="nav-item-content d-flex flex-row align-items-center">
                        <div class="d-flex flex-row align-items-center">
                            <i class="pi pi-fw pi-calendar icon"></i>
                            <div class="nav-item-title">{{ 'CALENDAR_NAVIGATION_TITLE' | translate }}</div>
                        </div>
                    </div>
                </li>
            </ng-container>

            <ng-container *ngIf="userHasOneRoleOf(ctx.user, ['member', 'dummy_user', 'instructor'], ['maintenance', 'admin'])">
                <li class="nav-item d-flex flex-column align-items-center pt-3 pb-3" [ngClass]="{ active: ctx.activeMenu === 'contingent' }" [routerLink]="'/contingent/booked'">
                    <div class="nav-item-content d-flex flex-row align-items-center">
                        <div class="d-flex flex-row align-items-center">
                            <i class="pi pi-fw pi-money-bill icon"></i>
                            <div class="nav-item-title">{{ 'CONTINGENT_NAVIGATION_TITLE' | translate }}</div>
                        </div>
                    </div>
                </li>
                <li class="nav-item d-flex flex-column align-items-center pt-3 pb-3" [ngClass]="{ active: ctx.activeMenu === 'shop' }" [routerLink]="'/accounting/shop'">
                    <div class="nav-item-content d-flex flex-row align-items-center">
                        <div class="d-flex flex-row align-items-center">
                            <i class="pi pi-fw pi-shopping-cart icon"></i>
                            <div class="nav-item-title">{{ 'ACCOUNTING_BUYBUNDLE_PAGE_TITLE' | translate }}</div>
                        </div>
                    </div>
                </li>
                <li class="nav-item d-flex flex-column align-items-center pt-3 pb-3" [ngClass]="{ active: ctx.activeMenu === 'invoice' }" [routerLink]="'/accounting/invoices'">
                    <div class="nav-item-content d-flex flex-row align-items-center">
                        <div class="d-flex flex-row align-items-center">
                            <i class="pi pi-fw pi-credit-card icon"></i>
                            <div class="nav-item-title">{{ 'INVOICE_NAVIGATION_TITLE' | translate }}</div>
                        </div>
                    </div>
                </li>
                <li class="nav-item d-flex flex-column align-items-center pt-3 pb-3" [ngClass]="{ active: ctx.activeMenu === 'cms' }" [routerLink]="'/cms/member/overview'">
                    <div class="nav-item-content d-flex flex-row">
                        <div class="d-flex flex-row">
                            <i class="pi pi-fw pi-book icon"></i>
                            <div class="nav-item-title">{{ 'CMS_PAGE_TITLE' | translate }}</div>
                        </div>
                    </div>
                </li>
                <li class="nav-item d-flex flex-column align-items-center pt-3 pb-3" [ngClass]="{ active: ctx.activeMenu === 'information' }" [routerLink]="'/information'">
                    <div class="nav-item-content d-flex flex-row align-items-center">
                        <div class="d-flex flex-row align-items-center">
                            <i class="pi pi-fw pi-info-circle icon"></i>
                            <div class="nav-item-title">{{ 'INFORMATION_PAGE_TITLE' | translate }}</div>
                        </div>
                    </div>
                </li>
            </ng-container>
        </ul>
    </nav>
</div>
